import get from 'lodash-es/get';

import { IPage } from './commonInterface';
import { BybitSearchListRef, IAjaxResult, MockData } from './commonInterface';
export const handleRangeData = (values: any = {}, calTime = true) => {
  const params = {
    ...values,
  };
  // tagSelect, Select多选数组[a,b]变成a,b
  Object.keys(values).forEach((key) => {
    if (Array.isArray(values[key])) {
      params[key] = values[key].toString();
    }
    // 去掉input首位空格
    if (typeof values[key] === 'string') {
      params[key] = params[key].trim();
    }
    if (!calTime && params[key] === '') {
      // 后端没有处理空情况，哎～～ 去掉空字符
      delete params[key];
    }
  });

  return params;
};

export function handleParams<T, K>(
  obj: any,
  currentParams: T,
  paramsFullCover?: K,
) {
  if (paramsFullCover) {
    currentParams = obj as T;
  } else if (obj) {
    currentParams = Object.assign({}, currentParams, obj);
  }

  return handleRangeData(currentParams, false);
}

export function handleResultData<RecordType>(
  rs: IAjaxResult = {} as IAjaxResult,
  dataSourceKey: string,
  mockData: MockData<RecordType>,
  handleFn: {
    message: any;
    setDataList: (dataList: RecordType[]) => void;
    setPageParams: (params: IPage) => void;
    onSuccess?: (rs: IAjaxResult) => void;
    onError?: (rs: Pick<IAjaxResult, 'result'>) => void;
    afterHandle?: () => void;
  },
) {
  if (rs?.ret_code === 0 && rs?.result) {
    handleFn.afterHandle && handleFn.afterHandle();
    if (handleFn.onSuccess) {
      handleFn.onSuccess(rs);
    }
    let arr: any[] = [];
    if (Array.isArray(get(rs, dataSourceKey))) {
      arr = get(rs, dataSourceKey) as any[];
      handleFn.setPageParams({
        currentPage: rs.result.current_page,
        lastPage: rs.result.last_page,
      });
    }
    handleFn.setDataList(arr.length ? arr : mockData.data);
  } else {
    handleFn.message.error(rs?.ret_msg || 'error');
    if (handleFn.onError) {
      handleFn.onError(rs);
      return;
    }
    handleFn.setDataList(mockData.data);
    handleFn.setPageParams({});
  }
}
export function refreshSearchTable<
  RecordType,
  FormValues = any,
  SearchValues = FormValues,
>(
  params: SearchValues,
  searchListRef: React.MutableRefObject<
    BybitSearchListRef<RecordType, FormValues, SearchValues> | undefined
  >,
) {
  if (searchListRef && searchListRef.current) {
    const searchListObj: Required<
      BybitSearchListRef<RecordType, FormValues, SearchValues>
    > = searchListRef.current;
    searchListObj.refreshList(params);
  }
}

export function getSearchListMethod<
  RecordType,
  FormValues = any,
  SearchValues = FormValues,
>(
  searchListRef: React.MutableRefObject<
    BybitSearchListRef<RecordType, FormValues, SearchValues>
  >,
): BybitSearchListRef<RecordType, FormValues, SearchValues> | undefined {
  if (searchListRef && searchListRef.current) {
    const searchListObj: BybitSearchListRef<
      RecordType,
      FormValues,
      SearchValues
    > = searchListRef.current;
    return searchListObj;
  }
}
export function showFnInSearchList<
  RecordType,
  FormValues = any,
  SearchValues = FormValues,
>(
  searchListRef: React.MutableRefObject<
    BybitSearchListRef<RecordType, FormValues, SearchValues>
  >,
  key: keyof BybitSearchListRef<RecordType, FormValues, SearchValues>,
) {
  const searchListObj = getSearchListMethod<
    RecordType,
    FormValues,
    SearchValues
  >(searchListRef);
  if (searchListObj && searchListObj[key]) {
    return searchListObj[key];
  }
  return false;
}
